import React from 'react';
import connect from 'Shared/connect';
import Button from 'Shared/Button';
import { translate } from 'Shared/translate';
import { setFeedback } from 'SiteLayout/GenericFeedbackBar/action-creators';
import Modal from 'Shared/Modal';
import Dialog, { DialogType } from 'Shared/Dialog';
import { postJson } from 'Shared/server';
import * as styles from './base.scss';
import { Input, Textarea } from 'Shared/Fields';
class SendTenderRequest extends React.PureComponent {
    constructor(props) {
        super(props);
        this.showModal = () => {
            this.setState({ isOpen: true });
        };
        this.hideModal = () => {
            this.setState({ isOpen: false });
        };
        this.onConfirm = () => {
            const query = {
                articleId: this.props.tenderProductArticleNumber,
                productName: this.props.tenderProductName,
                email: this.state.inputEmail,
                phoneNumber: this.state.inputPhone,
                message: this.state.inputMessage,
                customerName: this.props.currentUser.fullName,
                customerId: this.props.currentUser.customerId,
            };
            return postJson('/Tender/Send', query)
                .then(r => {
                if (r.result === 'success') {
                    this.props.setFeedback({ text: translate('/Tender/RequestSent'), type: 'success' });
                    this.setState({ inputEmail: '', inputPhone: '' });
                    return Promise.resolve();
                }
                return Promise.reject(null);
            })
                .catch(e => {
                this.props.setFeedback({ text: translate('/Tender/RequestError'), type: 'error' });
                return Promise.reject(null);
            });
        };
        this.validateEmail = (email) => {
            const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            this.setState({ validEmail: mailformat.test(email) });
            const model = {
                success: !!!email || !!mailformat.test(email),
                message: translate('/MyMenigo/CustomerProfileBlock/InvalidEmail'),
                value: email
            };
            return Promise.resolve(model);
        };
        this.validatePhone = (phone) => {
            const re = phone.length > 3;
            this.setState({ validPhone: re });
            const model = {
                success: !!!phone || !!re,
                message: translate('/MyMenigo/CustomerProfileBlock/InvalidFormatPhoneNumber'),
                value: phone
            };
            return Promise.resolve(model);
        };
        this.state = {
            isOpen: false,
            inputEmail: '',
            inputPhone: '',
            inputMessage: '',
            validEmail: false,
            validPhone: false,
        };
    }
    hasValidInput() {
        return !!this.state.inputEmail.length && !!this.state.inputPhone.length && this.state.validEmail;
    }
    renderModal() {
        return (React.createElement(Modal, { className: styles.broad, title: translate('/Tender/SendTenderToMe'), isOpen: this.state.isOpen, onClose: this.hideModal, reserveSpaceForCloseButton: true, fadeDesign: true },
            React.createElement("div", { className: styles.tenderProductDescriptionWrapper },
                React.createElement("h3", null, this.props.tenderProductName),
                React.createElement("p", { className: styles.artnummer },
                    translate('/ProductListing/ArticleNumber'),
                    " ",
                    this.props.tenderProductArticleNumber),
                React.createElement("p", null, translate('/Tender/PopupSubHeader'))),
            React.createElement("div", { className: styles.tenderInputWrapper__Top },
                React.createElement("div", null,
                    React.createElement(Input, { label: translate('/Tender/Email'), type: "email", name: "email", id: "email", value: this.state.inputEmail, onValidate: () => this.validateEmail(this.state.inputEmail), onChange: e => {
                            this.setState({ inputEmail: e.currentTarget.value });
                        } })),
                React.createElement("div", null,
                    React.createElement(Input, { label: translate('/Tender/Phone'), type: "tel", name: "phone", id: "phone", value: this.state.inputPhone, onValidate: () => this.validatePhone(this.state.inputPhone), onChange: e => {
                            this.setState({ inputPhone: e.currentTarget.value });
                        } }))),
            React.createElement("div", { className: styles.wrapper },
                React.createElement("label", { htmlFor: "msg" }, translate('/Tender/Message')),
                React.createElement("p", null, translate('/Tender/PopupSubText')),
                React.createElement(Textarea, { id: "msg", name: "msg", rows: 4, onChange: e => this.setState({ inputMessage: e.currentTarget.value }) })),
            React.createElement(Dialog, { type: DialogType.OkCancel, onConfirm: this.onConfirm, onCancel: this.hideModal, onStatusWasFulfilled: this.hideModal, disabled: !this.hasValidInput(), customAcceptText: translate('/Shared/Send') })));
    }
    render() {
        return (React.createElement("div", { className: styles.btnWrap },
            React.createElement(Button, { "data-opti-id": "component-request-quote-button", className: styles.btn, appearance: "small", onClick: this.showModal }, translate('/Tender/SendTender')),
            this.renderModal()));
    }
}
export default connect((state) => ({
    currentBreakpoint: state.currentBreakpoint,
    currentUser: state.currentUser,
}), (dispatch) => ({
    setFeedback: (data) => dispatch(setFeedback(data)),
}))(SendTenderRequest);
